import { Component, effect, inject } from '@angular/core';

import { SharedSignalsService } from '../../services/shared-signals.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { TranslationService } from '../../services/translation.service';
import { SessionVariable } from '../../enum/session-variable';
import { EnvService } from '../../../env.service';
@Component({
  selector: 'taly-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent {
  public envService = inject(EnvService);
  private storageService = inject(LocalStorageService);
  public translationService = inject(TranslationService);
  transferSignal = inject(SharedSignalsService);
  toggleCurrentLanguage: boolean = false;
  currentYear: number;
  osInfo!: string | null;
  appIcon!: string;
  appLink!: string;
  textDirection!: string;

  socialMedia: any[] = [
    {
      name: 'LinkedIn',
      icon: 'assets/images/LinkedIn-icon.svg',
      url: 'https://www.linkedin.com/company/taly-io/',
    },
    {
      name: 'Instagram',
      icon: 'assets/images/instagram-icon.svg',
      url: 'https://www.instagram.com/taly.io?igsh=MWlrdzh0Nm9sdzNmeQ%3D%3D&utm_source=qr',
    },
    // {
    //   name : 'Til-tok',
    //   icon : "assets/images/tik-tok.svg",
    //   url : "https://www.tiktok.com/@taly01581?_t=ZS-90HOfnYAvTu&_r=1"
    // },
    {
      name: 'Twiter',
      icon: 'assets/images/twiter.svg',
      url: 'https://x.com/talypay?s=11&t=ZBvnn70MW0LgBkooUsryKg',
    },
  ];

  paymentPartners: any[] = [
    {
      name: 'Lock',
      icon: 'assets/images/lock-icon.svg',
    },
    {
      name: 'Knet',
      icon: 'assets/images/knet-logo.svg',
    },
    {
      name: 'Master Card',
      icon: 'assets/images/master-card-logo.svg',
    },
    {
      name: 'Visa Card',
      icon: 'assets/images/footer-visa-icon.svg',
    },
    {
      name: 'Apple Pay',
      icon: 'assets/images/apple-icon.svg',
    },
    {
      name: 'Gpay',
      icon: 'assets/images/gpay-icon.svg',
    },
  ];

  constructor() {
    effect(() => {
      this.textDirection = this.transferSignal.textDirection();

      this.osInfo = this.transferSignal?.userAgentType();

      if (this.osInfo == 'iOS') {
        this.appIcon = 'assets/images/app-store-img.svg';
        this.appLink = this.envService.appIOSURL;
      } else {
        this.appIcon = 'assets/images/google-play-store.svg';
        this.appLink = this.envService.appAndroidURL;
      }
    });

    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  }

  toggleText() {
    this.toggleCurrentLanguage = !this.toggleCurrentLanguage;
    const currentLanguage = this.toggleCurrentLanguage ? 'ar-KW' : 'en-US';
    this.transferSignal.setTextDirection(currentLanguage == 'ar-KW' ? 'rtl' : 'ltr');
    this.storageService.setItem(SessionVariable.LANGUAGE, currentLanguage);
    this.translationService.switchLanguage(currentLanguage);
  }

  onClickLink(event: MouseEvent, url: string) {
    event.preventDefault();
    this.envService?.onLinkClick(event, url);
  }

  onKeyupLink() {
    console.log('Enter key pressed');
  }
}
